import { TextField } from "@mui/material";
import React, { Dispatch, KeyboardEvent, SetStateAction, useState } from "react";

import { BaseAutocomplete } from "@/components/a-autocomplete";

const autocompleteProps = {
  disableCloseOnSelect: true,
};

type NumberListInputProps = {
  value: number[];
  onChange: (newVal: number[]) => void;
  label: string;
  parse?: (val: number) => boolean;
  options?: number[];
};

export const NumberListInput = ({
  value,
  onChange,
  label,
  parse,
  options: defaultOptions,
}: NumberListInputProps) => {
  const [options, setOptions] = useState(() => {
    return defaultOptions || value.filter((item) => !!item);
  });

  const handleOptionArrayKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      const newValue = (event.target as HTMLInputElement).value;
      const newNumber = parseInt(newValue, 10);
      if (isNaN(newNumber as number)) {
        return;
      }
      if (parse && !parse(newNumber)) {
        return;
      }
      if (!options.includes(newNumber as number)) {
        setOptions((prevState) => {
          return [...prevState, newNumber];
        });
      }
      if (!value.includes(newNumber)) {
        onChange(Array.from(new Set([...value, newNumber])));
      }
    }
  };

  return (
    <BaseAutocomplete
      onChange={(_event, newValue) => {
        onChange(newValue);
      }}
      value={value}
      options={options}
      multiple
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label={label}
          variant="outlined"
          onKeyDown={handleOptionArrayKeyDown}
        />
      )}
      sx={{ width: "100%" }}
      {...autocompleteProps}
    />
  );
};
